<template>
  <div class="participants-list">
    <category-participants
      :label="$t('fip.participantsList.dirHeader')"
      :participants="participantsByCategory['DIR']" />
    <category-participants
      :label="$t('fip.participantsList.actHeader')"
      :participants="participantsByCategory['ACT']" />
    <category-participants
      :label="$t('fip.participantsList.mesHeader')"
      :participants="participantsByCategory['MES']" />
    <category-participants
      :label="$t('fip.participantsList.autHeader')"
      :participants="participantsByCategory['AUT']" />
    <category-participants
      :label="$t('fip.participantsList.preHeader')"
      :participants="participantsByCategory['PRE']" />
    <category-participants
      :label="$t('fip.participantsList.proHeader')"
      :participants="participantsByCategory['PRO']" />
    <category-participants
      :label="$t('fip.participantsList.choHeader')"
      :participants="participantsByCategory['CHO']" />
  </div>
</template>

<script>
import { NUMBERTOSHOW, SEQUENCE } from './participants-list.config'
import _get from 'lodash/get'
import CategoryParticipants from './categoryParticipants/CategoryParticipants'

export default {
  name: 'ParticipantsList',
  components: { CategoryParticipants },
  props: {
    artists: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      participants: {}
    }
  },
  computed: {
    /**
     * Retrieve the 2 first categories of video participants respecting this order:
     * - DIR (director)
     * - ACT (actor)
     * - MES (stage director)
     * - AUT (author)
     * - PRE (presenter)
     * - PRO (producer)
     * - CHO (choregraph)
     */
    participantsByCategory () {
      let itemCount = 0

      return SEQUENCE.reduce((acc, cur) => {
        const categoryParticipants = _get(this.artists, cur, [])

        if (itemCount < NUMBERTOSHOW && categoryParticipants.length !== 0) {
          acc[cur] = categoryParticipants.map(artist => (artist.firstName && artist.lastName) ? artist.firstName + ' ' + artist.lastName : artist.firstName || artist.lastName)
          itemCount++
        }

        return acc
      }, {})
    }
  }
}
</script>
